import { dictationCommandsByLocale, locales } from '@shared/constants/localization/LocalizationConstants';
import { LocalizationModelKeys, VoiceLocales } from '@shared/models/localization/Locales';
import { CommonResourceKey } from '@shared/models/ResourceKeys';

export function isLocale(locale: string): locale is VoiceLocales {
    return locales.voice.includes(locale as VoiceLocales);
}

/**
 *
 * @param locale
 * @returns the translation key for the language
 */
export function getLocaleTranslationKey(locale: string): CommonResourceKey {
    if (isLocale(locale)) {
        return `common:localization.locales.${locale}` as CommonResourceKey;
    }
    return 'common:localization.unsupported.title';
}

export const getLanguageOnly = (locale: string): string => {
    return locale.toLowerCase().split('-')[0];
};

/**
 * Gets the client supported and cultural fallback locale if supported
 * @param locale standard locale code
 * @param variant LocalizationModelKeys
 * @returns valid client string if there is a supported locale, otherwise returns null
 */
export const getSupportedLocale = (locale: string, variant: LocalizationModelKeys): string | null => {
    let result = null;
    if (locale) {
        const localeOptions: string[] = locales[variant];
        const localeLower = locale.toLowerCase();
        const languageOnly = getLanguageOnly(locale);

        if (localeOptions.includes(localeLower)) {
            result = localeLower;
        } else if (localeOptions.includes(languageOnly)) {
            result = languageOnly;
        } else if (localeLower.startsWith('en') && variant == 'voice') {
            result = 'en-us'; // exception for English Voice because the base is en-us
        }
    }

    return result;
};

export const getDefaultDictationCommands = (locale: string) => {
    const language = getSupportedLocale(locale, 'voice');

    let result = dictationCommandsByLocale['en-us'];
    if (language) {
        result = dictationCommandsByLocale[language as VoiceLocales];
    }

    return result;
};
